import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'concatArray',
  standalone: true
})
export class ConcatArrayPipe implements PipeTransform {

  transform<T>( ...arrayList: Array<Array<T>>): unknown {
    return arrayList.flat();
  }

}
